var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 1.33333C9.33333 0.979711 9.19286 0.640573 8.94281 0.390525C8.69276 0.140476 8.35362 0 8 0C7.64638 0 7.30724 0.140476 7.05719 0.390525C6.80714 0.640573 6.66667 0.979711 6.66667 1.33333V6.66667H1.33333C0.979711 6.66667 0.640573 6.80714 0.390525 7.05719C0.140476 7.30724 0 7.64638 0 8C0 8.35362 0.140476 8.69276 0.390525 8.94281C0.640573 9.19286 0.979711 9.33333 1.33333 9.33333H6.66667V14.6667C6.66667 15.0203 6.80714 15.3594 7.05719 15.6095C7.30724 15.8595 7.64638 16 8 16C8.35362 16 8.69276 15.8595 8.94281 15.6095C9.19286 15.3594 9.33333 15.0203 9.33333 14.6667V9.33333H14.6667C15.0203 9.33333 15.3594 9.19286 15.6095 8.94281C15.8595 8.69276 16 8.35362 16 8C16 7.64638 15.8595 7.30724 15.6095 7.05719C15.3594 6.80714 15.0203 6.66667 14.6667 6.66667H9.33333V1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.c6fe0ad5beb53490a36c50f2ed2d1cfa.svg";
export { ForwardRef as ReactComponent };